export const Envs = {
  BFF_WEB_URL: process.env['NX_BFF_WEB_URL'] ?? process.env['REACT_APP_HUB_API'],
  ENV: process.env['ENVIRONMENT'] ?? process.env['REACT_APP_CUSTOM_NODE_ENV'],
  YUNO_PUBLIC_API_KEY: process.env['NX_YUNO_PUBLIC_API_KEY'] ?? process.env['REACT_APP_YUNO_PUBLIC_API_KEY'],
  YUNO_API_URL: process.env['NX_YUNO_API_URL'] ?? process.env['REACT_APP_YUNO_API_URL'],
  IUGU_ACCOUNT_ID: process.env['NX_IUGU_ACCOUNT_ID'] ?? process.env['REACT_APP_IUGU_ACCOUNT_ID'],
  IUGU_TEST_MODE: process.env['NX_IUGU_TEST_MODE'] ?? process.env['REACT_APP_IUGU_TEST_MODE'],
}
